// extracted by mini-css-extract-plugin
export default {"statusBtn":"styles_statusBtn__fjzsb","rejectionWarning":"styles_rejectionWarning__mpPT1"};